import {Component, OnInit, OnDestroy} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient} from "@angular/common/http";
import {of, switchMap, Observable, Subject, EMPTY} from "rxjs";
import {retry, catchError, takeUntil} from "rxjs/operators";
import {FintechService} from "../../../services/fintech.service";
import {countries} from "../../../common";
import {ToastrService} from "ngx-toastr";

@Component({
    selector: 'app-fintech-shipping',
    templateUrl: './fintech-shipping.component.html',
    styleUrls: ['./fintech-shipping.component.scss']
})
export class FintechShippingComponent implements OnInit, OnDestroy {

    showShippingInfo = false;
    shipForm: FormGroup;

    shippingInfo;

    country;
    m_countries = countries;
    private destroy$ = new Subject<void>();


    constructor(public fintechService: FintechService,
                private http: HttpClient,
                private formBuilder: FormBuilder,
                private toastr: ToastrService) {
        this.shipForm = this.formBuilder.group({
            shipCompany: ['', [Validators.required, Validators.minLength(2)]],
            shipFirstName: ['', [Validators.required, Validators.minLength(2)]],
            shipLastName: ['', [Validators.required, Validators.minLength(2)]],
            shipAddress1: ['', [Validators.required, Validators.minLength(2)]],
            shipAddress2: ['', [Validators.required, Validators.minLength(2)]],
            shipCity: ['', [Validators.required, Validators.minLength(2)]],
            shipState: ['', [Validators.required, Validators.minLength(2)]],
            shipCountry: ['', [Validators.required, Validators.minLength(2)]],
            shipZipCode: ['', [Validators.required, Validators.minLength(2)]],
            shipPhone1: ['', [Validators.required, Validators.minLength(2)]],
            shipPhone2: ['', [Validators.required, Validators.minLength(2)]],
            shipEmail: ['', [Validators.required, Validators.minLength(2)]]
        });
        this.fintechService.notify$.pipe(takeUntil(this.destroy$)).subscribe( msg => {
            if (this.fintechService.data.shippingInfo != null) {
                this.shippingInfo = this.fintechService.data.shippingInfo;

                if (this.fintechService.data.paymentInfo == null) {
                    this.showShippingInfo = true;
                }
            }
        });

        this.fintechService.busy$.pipe(takeUntil(this.destroy$)).subscribe( busy => {
            if (busy) {
                this.shipForm.disable();
            } else {
                this.shipForm.enable();
            }
        });
    }


    ngOnInit(): void {

    }


    onEditShipping() {
        this.shipForm.get('shipCompany').patchValue(this.shippingInfo?.company, {emitEvent: false});
        this.shipForm.get('shipFirstName').patchValue(this.shippingInfo?.firstName, {emitEvent: false});
        this.shipForm.get('shipLastName').patchValue(this.shippingInfo?.lastName, {emitEvent: false});
        this.shipForm.get('shipAddress1').patchValue(this.shippingInfo?.address1, {emitEvent: false});
        this.shipForm.get('shipAddress2').patchValue(this.shippingInfo?.address2, {emitEvent: false});
        this.shipForm.get('shipCity').patchValue(this.shippingInfo?.city, {emitEvent: false});
        this.shipForm.get('shipState').patchValue(this.shippingInfo?.state, {emitEvent: false});
        this.shipForm.get('shipCountry').patchValue(this.shippingInfo?.country, {emitEvent: false});
        this.shipForm.get('shipZipCode').patchValue(this.shippingInfo?.zipCode, {emitEvent: false});
        this.shipForm.get('shipPhone1').patchValue(this.shippingInfo?.phone1, {emitEvent: false});
        this.shipForm.get('shipPhone2').patchValue(this.shippingInfo?.phone2, {emitEvent: false});
        this.shipForm.get('shipEmail').patchValue(this.shippingInfo?.email, {emitEvent: false});


        this.fintechService.editMode = "shipping";
    }

    onCancelShip() {
        this.fintechService.editMode = "info";
    }

    onShipCountry() {
        this.shippingInfo.country =  this.shipForm.value.shipCountry;
    }

    onUpdateShipping() {
        if (!this.shipForm.valid) {
            this.toastr.error('Please fill out all required fields correctly.', 'Validation Error');
            return;
        }

        this.fintechService.setBusy(true);

        this.shippingInfo.company =  this.shipForm.value.shipCompany;
        this.shippingInfo.firstName =  this.shipForm.value.shipFirstName;
        this.shippingInfo.lastName =  this.shipForm.value.shipLastName;
        this.shippingInfo.address1 =  this.shipForm.value.shipAddress1;
        this.shippingInfo.address2 =  this.shipForm.value.shipAddress2;
        this.shippingInfo.city =  this.shipForm.value.shipCity;
        this.shippingInfo.state =  this.shipForm.value.shipState;
        this.shippingInfo.country =  this.shipForm.value.shipCountry;
        this.shippingInfo.zipCode =  this.shipForm.value.shipZipCode;
        this.shippingInfo.phone1 =  this.shipForm.value.shipPhone1;
        this.shippingInfo.phone2 =  this.shipForm.value.shipPhone2;
        this.shippingInfo.email =  this.shipForm.value.shipEmail;


        const obs$ = this.fintechService.getPayerToken().pipe(
            switchMap(payerToken => {
                const options: any = {
                    token: payerToken,
                    company: this.shippingInfo.company,
                    firstName: this.shippingInfo.firstName,
                    lastName: this.shippingInfo.lastName,
                    address1: this.shippingInfo.address1,
                    address2: this.shippingInfo.address2,
                    city: this.shippingInfo.city,
                    state: this.shippingInfo.state,
                    country: this.shippingInfo.country,
                    zipCode: this.shippingInfo.zipCode,
                    phone1: this.shippingInfo.phone1,
                    phone2: this.shippingInfo.phone2,
                    email: this.shippingInfo.email
                };
                const url = "https://pay.signage.me:8443/fintech/updateShippingInfo";
                return this.http.post(url, options).pipe(
                    retry({
                        count: 5,
                        delay: (error, retryCount) => {
                            this.toastr.info(`Please wait connecting to server... (${retryCount})`, `FinTech`, { timeOut: 3000 });
                            return of(error);
                        },
                    }),
                    catchError(error => {
                        console.error('Error updating shipping info after retries:', error);
                        this.toastr.error('Failed to update shipping information. Please try again.', 'FinTech', { timeOut: 5000 });
                        this.fintechService.setBusy(false);
                        return EMPTY;
                    })
                );
            }),
            switchMap(ret => {
                this.fintechService.editMode = "info";
                this.fintechService.setBusy(false);
                this.toastr.success('Shipping information updated successfully.', 'FinTech');
                return of('a');
            }),
            takeUntil(this.destroy$)
        );
        obs$.subscribe();
    }

    onCopyFromBilling() {
    }

    ngOnDestroy(): void {
        this.destroy$.next();
        this.destroy$.complete();
    }
}
